"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var tableHeaderHeight = exports.tableHeaderHeight = "50px";
var tableGroupHeaderHeight = exports.tableGroupHeaderHeight = "50px";
var tableRowHeightDefault = exports.tableRowHeightDefault = "50px";
var tableRowHeightCondensed = exports.tableRowHeightCondensed = "40px";
var tableRowHeightExtraCondensed = exports.tableRowHeightExtraCondensed = "28px";
var tableSummaryRowHeightSingle = exports.tableSummaryRowHeightSingle = "60px";
var tableSummaryRowHeightMulti = exports.tableSummaryRowHeightMulti = "32px";
var tableFixedColShadow = exports.tableFixedColShadow = "2px 0 4px 0 rgba(19, 21, 23, 0.2)";
var tableFixedRowShadow = exports.tableFixedRowShadow = "0 2px 4px 0 rgba(19, 21, 23, 0.2)";